import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import React from 'react';
import 'prop-types';
import classNames from 'classnames';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
import { Image } from '@vpp-frontend-components/image';
import { Icon } from '@vpp-frontend-components/icon';
import { Notification } from '@andes/badge';
var _Notification, _Notification2;
const getIcon = iconId => {
  switch (iconId) {
    case 'ERROR_BADGE':
      return _Notification || (_Notification = /*#__PURE__*/_jsx(Notification, {
        type: "error",
        size: "small"
      }));
    case 'WARNING_BADGE':
      return _Notification2 || (_Notification2 = /*#__PURE__*/_jsx(Notification, {
        type: "warning",
        size: "small"
      }));
    default:
      return null;
  }
};
const namespace = 'ui-pdp-action-row';
const ActionRow = _ref => {
  var _selected$values;
  let {
    className = '',
    disabled = false,
    label = null,
    selected = null,
    subtitle = null,
    thumbnail = null,
    onClick = null,
    modifier = 'primary',
    url = null,
    htmlTarget = '_self',
    figure = null
  } = _ref;
  const showError = !disabled && modifier === 'error';
  const buildLeftIcon = () => /*#__PURE__*/_jsx("figure", {
    className: classNames('ui-pdp-icon--figure-left', [{
      'ui-pdp-icon--disabled': disabled
    }])
  }, void 0, figure);
  const content = /*#__PURE__*/React.createElement(React.Fragment, null, figure && buildLeftIcon(), label && /*#__PURE__*/_jsx("span", {
    className: `${namespace}__label`
  }, void 0, label), /*#__PURE__*/_jsx("div", {
    className: `${namespace}__content`
  }, void 0, !!(selected !== null && selected !== void 0 && selected.text_icon) && getIcon(selected.text_icon.id), selected && /*#__PURE__*/_jsx("span", {
    className: classNames(`${namespace}__selected`, {
      [`ui-pdp-color--${selected.color}`]: selected.color
    }, {
      'ui-pdp-action-row__with-thumbnail': thumbnail
    })
  }, void 0, componentEnhance.jsx(selected.text, (_selected$values = selected.values) !== null && _selected$values !== void 0 ? _selected$values : null)), subtitle && /*#__PURE__*/_jsx("span", {
    className: `${namespace}__subtitle`
  }, void 0, componentEnhance.jsx(subtitle.text || subtitle, subtitle.values)), thumbnail && /*#__PURE__*/React.createElement(Image, _extends({
    lazyload: false,
    className: `${namespace}__thumbnail`
  }, thumbnail)), !disabled && /*#__PURE__*/_jsx(Icon, {
    id: "chevron",
    className: classNames('ui-pdp-icon--chevron-right', {
      'ui-pdp-icon--chevron-right__error': showError
    })
  })));
  const modifierClass = {
    [`ui-pdp-action-row--${showError ? 'error-600' : modifier}`]: modifier
  };
  const isLink = !disabled && url;
  const actionCallback = disabled ? null : onClick;
  return !isLink ? /*#__PURE__*/_jsx("span", {
    "data-testid": "action-row-span",
    className: classNames(namespace, className, {
      'ui-pdp-action-row--disabled': disabled
    }, modifierClass),
    onClick: actionCallback,
    onKeyUp: actionCallback,
    role: "button",
    tabIndex: "-1"
  }, void 0, content) : /*#__PURE__*/_jsx("a", {
    "data-testid": "action-row-anchor",
    href: url,
    className: classNames(namespace, className, modifierClass),
    onClick: actionCallback,
    target: htmlTarget || '_self'
  }, void 0, content);
};
export { ActionRow, getIcon };
